/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import $gkc from '../typeScriptServiceClientHost';
import { $$jc } from '../ui/activeJsTsEditorTracker';
import { Lazy } from '../utils/lazy';
import { $Eic, ProjectType } from '../tsconfig';
import { Command } from './commandManager';

export class $ikc implements Command {
	public readonly id = 'typescript.goToProjectConfig';

	public constructor(
		private readonly a: $$jc,
		private readonly b: Lazy<$gkc>,
	) { }

	public execute() {
		const editor = this.a.activeJsTsEditor;
		if (editor) {
			$Eic(ProjectType.TypeScript, this.b.value.serviceClient, editor.document.uri);
		}
	}
}

export class $jkc implements Command {
	public readonly id = 'javascript.goToProjectConfig';

	public constructor(
		private readonly a: $$jc,
		private readonly b: Lazy<$gkc>,
	) { }

	public execute() {
		const editor = this.a.activeJsTsEditor;
		if (editor) {
			$Eic(ProjectType.JavaScript, this.b.value.serviceClient, editor.document.uri);
		}
	}
}
